export interface ShowItem {
  id: string;
  title: string;
  type: 'tv' | 'movie';
  genres: string[];
  region: string;
  year: number;
  rating: number;
  cover: string;
  summary: string;
  synopsis: string;
  director: string;
  cast: string[];
  airInfo: string;
  tags: string[];
  featured?: boolean;
  hot?: boolean;
}

export const shows: ShowItem[] = [
  {
    id: 'tv-001',
    title: '长安月下',
    type: 'tv',
    genres: ['剧情', '古装', '悬疑'],
    region: '内地',
    year: 2025,
    rating: 8.7,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%20moody%20navy%20blue%20night%20scene%20with%20ancient%20city%20gate%2C%20lantern%20light%2C%20cinematic%20composition%2C%20elegant%20costume%20silhouette%2C%20dramatic%20lighting%2C%20high%20detail%20movie%20poster%20style&width=640&height=900&seq=show-tv-001-a&orientation=portrait',
    summary: '长安城内接连发生命案，年轻御史与神秘捕快联手追查幕后真相，牵出一桩尘封多年的宫廷旧案。',
    synopsis:
      '大历十二年，长安城内接连发生数起离奇命案，死者皆与多年前一桩宫廷旧案有关。年轻御史裴衍临危受命彻查案情，却在调查过程中结识神秘捕快阿璃。两人起初因立场不同屡生摩擦，却在层层线索的推进中逐渐发现，案件背后牵扯的不止是江湖恩怨，更有朝堂之上的权力博弈。随着真相逐步浮出水面，裴衍发现自己的身世竟与当年旧案有着千丝万缕的联系。在家族荣辱与朝堂正义之间，他必须做出抉择。全剧以悬疑探案为主线，辅以细腻的情感铺陈，通过裴衍与阿璃携手破案的过程，展现大历盛世下暗流涌动的权谋图景，也刻画了乱世中小人物坚守本心的动人故事。',
    director: '沈知微',
    cast: ['林疏桐', '陆珩', '周见山', '苏棠'],
    airInfo: '2025年每周五、周六晚20:00更新',
    tags: ['探案', '权谋', '双男主'],
    featured: true,
    hot: true,
  },
  {
    id: 'tv-002',
    title: '烟火人间',
    type: 'tv',
    genres: ['家庭', '伦理', '都市'],
    region: '内地',
    year: 2025,
    rating: 8.3,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20poster%2C%20warm%20orange%20evening%20light%20over%20city%20apartment%20balcony%2C%20three%20generations%20silhouette%2C%20cozy%20domestic%20atmosphere%2C%20cinematic%20portrait%20composition&width=640&height=900&seq=show-tv-002-a&orientation=portrait',
    summary: '三代同堂的普通家庭在时代变迁中经历聚散离合，用烟火日常诠释中国式亲情的温暖与坚韧。',
    synopsis:
      '故事围绕江城一户三代同堂的普通家庭展开。年迈的父亲坚持经营多年的老字号早点铺，大女儿在职场打拼多年却面临中年危机，小儿子怀揣创业梦想却屡屡碰壁。随着老城区改造计划的推进，一家人围绕老房子去留、事业选择、子女教育等问题产生分歧与碰撞。剧集没有刻意制造狗血冲突，而是通过柴米油盐的日常细节，细腻呈现两代人观念的差异与和解。姐弟二人从互相埋怨到彼此理解，父母从固执己见到学会放手，一家人最终在风雨中重新凝聚。全剧基调温暖治愈，以小见大地折射出普通中国家庭在时代浪潮中的坚守与变迁。',
    director: '何建国',
    cast: ['王砚秋', '李明哲', '陈小满', '张桂芳'],
    airInfo: '2025年每周一至周三晚19:30更新',
    tags: ['亲情', '治愈', '现实主义'],
    featured: true,
    hot: true,
  },
  {
    id: 'tv-003',
    title: '边境缉踪',
    type: 'tv',
    genres: ['悬疑', '犯罪', '动作'],
    region: '内地',
    year: 2024,
    rating: 8.1,
    cover: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20poster%2C%20dark%20navy%20blue%20tone%2C%20border%20checkpoint%20at%20night%2C%20detective%20silhouette%20with%20flashlight%2C%20tense%20cinematic%20atmosphere%2C%20high%20contrast%20lighting&width=640&height=900&seq=show-tv-003-a&orientation=portrait',
    summary: '缉毒警察深入边境小镇卧底，与跨境犯罪集团斗智斗勇，揭开一张隐藏多年的贩毒网络。',
    synopsis:
      '西南边境小镇表面平静，实则暗藏一条运行多年的跨境贩毒通道。缉毒警察顾北辰奉命潜入当地，以货运司机的身份接近犯罪集团核心。在卧底过程中，他与集团二号人物之女产生微妙的情感纠葛，也屡次身陷险境。随着调查深入，顾北辰发现案件背后牵涉的不仅是普通毒贩，还有境外势力与本地保护伞的勾连。全剧节奏紧凑，动作场面扎实，在警匪对抗的主线之外，也刻画了基层缉毒警察的艰辛与信念，展现了正义与人性在极端环境下的较量。',
    director: '赵振邦',
    cast: ['顾北辰', '马文博', '苏雨桐'],
    airInfo: '2024年已完结，全36集',
    tags: ['缉毒', '卧底', '动作'],
    hot: true,
  },
  {
    id: 'tv-004',
    title: '青春合伙人',
    type: 'tv',
    genres: ['青春', '励志', '职场'],
    region: '内地',
    year: 2025,
    rating: 7.9,
    cover: 'https://readdy.ai/api/search-image?query=Youth%20startup%20drama%20poster%2C%20bright%20modern%20office%20space%2C%20group%20of%20young%20entrepreneurs%2C%20warm%20orange%20and%20navy%20color%20accents%2C%20energetic%20cinematic%20composition&width=640&height=900&seq=show-tv-004-a&orientation=portrait',
    summary: '四位性格迥异的年轻人从大学社团走向创业合伙人，共同经历理想与现实的碰撞。',
    synopsis:
      '四名大学同窗毕业后放弃稳定工作，合伙创立一家主打原创设计的文创公司。从最初挤在出租屋里画图纸，到公司逐渐步入正轨，他们经历了资金链断裂、团队分歧、市场竞争等重重考验。剧中既有创业初期的热血冲动，也有理想照进现实后的迷茫与挣扎。随着公司逐渐壮大，四人也在各自的成长中重新认识友情、爱情与自我价值。全剧以轻快明亮的影像风格，展现当代年轻人在创业浪潮中的坚持与蜕变。',
    director: '林小满',
    cast: ['韩哲', '夏梦', '赵子轩', '林微'],
    airInfo: '2025年每周日晚21:00更新',
    tags: ['创业', '友情', '成长'],
  },
  {
    id: 'movie-001',
    title: '浪潮之上',
    type: 'movie',
    genres: ['剧情', '励志'],
    region: '内地',
    year: 2025,
    rating: 8.5,
    cover: 'https://readdy.ai/api/search-image?query=Inspirational%20drama%20film%20poster%2C%20lone%20surfer%20silhouette%20facing%20ocean%20waves%20at%20sunset%2C%20deep%20navy%20blue%20sky%20with%20warm%20orange%20horizon%2C%20cinematic%20epic%20composition&width=640&height=900&seq=show-movie-001-a&orientation=portrait',
    summary: '一名退役运动员在人生低谷中重拾冲浪梦想，用一场海上归来的旅程完成自我救赎。',
    synopsis:
      '曾经的国家队运动员陈野因一次重大失误被迫退役，沉寂多年后远走沿海小城，以教冲浪为生。在一次意外事故中，他重新燃起对竞技的渴望，决定挑战已阔别多年的职业赛场。影片通过陈野训练复出的过程，穿插他与小镇居民、徒弟之间温暖而真实的互动，展现一个普通人跌倒后重新站起的勇气。全片摄影风格开阔大气，海浪与晨昏光影贯穿始终，是一部兼具视觉美感与情感深度的励志佳作。',
    director: '周明远',
    cast: ['陈野', '林晓雨', '黄建国'],
    airInfo: '2025年院线上映',
    tags: ['体育', '励志', '救赎'],
    featured: true,
    hot: true,
  },
  {
    id: 'movie-002',
    title: '雾中迷局',
    type: 'movie',
    genres: ['悬疑', '犯罪'],
    region: '韩国',
    year: 2024,
    rating: 8.4,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20mystery%20thriller%20movie%20poster%2C%20foggy%20city%20street%20at%20night%2C%20lone%20detective%20figure%2C%20deep%20blue%20and%20cold%20tone%20lighting%2C%20tense%20cinematic%20mood&width=640&height=900&seq=show-movie-002-a&orientation=portrait',
    summary: '一桩十年悬案因一场浓雾重新浮出水面，退休警探重启调查，发现真相远比想象复杂。',
    synopsis:
      '十年前的一起失踪案因新线索浮现而被重新提起，已经退休的警探韩胜宇再度出山。随着调查推进，他发现案件牵连当年多名重要人物，而这些人如今身份显赫，极力阻挠调查。影片以浓雾笼罩的港口小城为背景，层层反转的剧情与冷峻的影像风格相互映衬，呈现出一部张力十足的悬疑佳作，也引发观众对正义与权力的深刻思考。',
    director: '金敏哲',
    cast: ['韩胜宇', '吴允书'],
    airInfo: '2024年全球院线上映',
    tags: ['悬疑', '反转', '警匪'],
    hot: true,
  },
  {
    id: 'movie-003',
    title: '星河来信',
    type: 'movie',
    genres: ['科幻', '爱情'],
    region: '美国',
    year: 2025,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20romance%20movie%20poster%2C%20couple%20standing%20under%20starry%20night%20sky%20with%20distant%20galaxy%2C%20deep%20navy%20blue%20cosmic%20background%20with%20warm%20orange%20light%20accent%2C%20dreamy%20cinematic%20composition&width=640&height=900&seq=show-movie-003-a&orientation=portrait',
    summary: '一封穿越时空的来信，让两个相隔十年的灵魂彼此牵绊，共同对抗命运的安排。',
    synopsis:
      '天文学家艾拉意外接收到一段来自十年后的神秘信号，发信人竟是她素未谋面却似曾相识的人。两人借助这段跨越时空的通讯逐渐建立起深厚的情感联系，却也发现彼此的相遇将带来无法预知的蝴蝶效应。影片将浪漫爱情与硬核科幻设定巧妙融合，恢弘的星空视效与细腻的情感刻画相得益彰，是一部兼具想象力与感染力的年度科幻爱情佳作。',
    director: 'Laura Bennett',
    cast: ['艾拉·陈', '诺亚·卡特'],
    airInfo: '2025年全球同步上映',
    tags: ['科幻', '爱情', '时空'],
    featured: true,
  },
  {
    id: 'tv-005',
    title: '岁月如歌',
    type: 'tv',
    genres: ['年代', '剧情'],
    region: '内地',
    year: 2023,
    rating: 8.6,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%2C%201980s%20nostalgic%20street%20scene%2C%20warm%20golden%20orange%20light%2C%20family%20gathering%20silhouette%2C%20vintage%20cinematic%20composition&width=640&height=900&seq=show-tv-005-a&orientation=portrait',
    summary: '一个纺织厂家庭跨越四十年的悲欢离合，见证时代洪流下普通人的命运沉浮。',
    synopsis:
      '上世纪八十年代，纺织厂青年工人林建国与妻子秦素芬白手起家，含辛茹苦抚养三个子女长大成人。剧集跨越四十年时间线，从改革开放初期到新世纪，描绘了这个家庭在时代浪潮中的起伏命运。子女们各自经历下海经商、求学深造、出国打拼等不同人生道路，最终又因亲情羁绊重新团聚。全剧以细腻质朴的叙事手法，还原了特定年代的生活质感，是一部兼具年代厚度与情感温度的家庭史诗。',
    director: '吴建军',
    cast: ['林建国', '秦素芬', '林晓冬', '林晓雪'],
    airInfo: '2023年已完结，全42集',
    tags: ['年代', '家庭', '史诗'],
  },
  {
    id: 'tv-006',
    title: '都市怪谈社',
    type: 'tv',
    genres: ['悬疑', '喜剧', '都市'],
    region: '内地',
    year: 2025,
    rating: 7.6,
    cover: 'https://readdy.ai/api/search-image?query=Urban%20mystery%20comedy%20drama%20poster%2C%20quirky%20night%20city%20street%20with%20neon%20orange%20lights%2C%20group%20of%20young%20friends%2C%20playful%20cinematic%20tone%2C%20navy%20blue%20night%20sky&width=640&height=900&seq=show-tv-006-a&orientation=portrait',
    summary: '一群年轻人成立都市怪谈调查社，用轻松诙谐的方式揭开各种都市传说背后的真相。',
    synopsis:
      '自由撰稿人苏然偶然卷入一桩都市怪谈事件，机缘巧合下与三位性格迥异的伙伴组成了"怪谈调查社"。他们穿梭于城市的大街小巷，调查从电梯幽灵到深夜出租车等各种光怪陆离的都市传闻。每个案件看似诡异离奇，背后却往往藏着普通人的心酸与温情。剧集以轻喜剧风格包裹悬疑外壳，节奏明快，笑点与温情并存，是一部适合全年龄段观看的都市轻悬疑佳作。',
    director: '郑小天',
    cast: ['苏然', '冯宇', '程雨嘉', '老K'],
    airInfo: '2025年每周四、周五晚20:00更新',
    tags: ['轻悬疑', '喜剧', '都市传说'],
  },
  {
    id: 'movie-004',
    title: '归途',
    type: 'movie',
    genres: ['剧情', '家庭'],
    region: '内地',
    year: 2024,
    rating: 8.2,
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20family%20drama%20movie%20poster%2C%20lone%20figure%20walking%20on%20countryside%20road%20at%20dusk%2C%20warm%20orange%20sunset%20with%20deep%20blue%20sky%2C%20emotional%20cinematic%20composition&width=640&height=900&seq=show-movie-004-a&orientation=portrait',
    summary: '常年在外打拼的儿子因父亲病重匆匆归乡，在短短数日里重新理解何为家与亲情。',
    synopsis:
      '常年在外地工作的程远因父亲突发重病连夜赶回阔别多年的家乡。短短几天的相处中，他逐渐发现自己错过了父亲太多的晚年时光，也重新认识了那些被自己忽视的家乡人情。影片没有刻意煽情，而是用克制细腻的镜头语言，记录下一场迟来的和解与理解。朴素的乡土影像与真挚的情感表达，让这部电影成为近年来口碑最佳的家庭题材作品之一。',
    director: '贾明',
    cast: ['程远', '程建国', '李秀兰'],
    airInfo: '2024年院线上映',
    tags: ['亲情', '乡土', '治愈'],
  },
  {
    id: 'movie-005',
    title: '极速边界',
    type: 'movie',
    genres: ['动作', '犯罪'],
    region: '美国',
    year: 2025,
    rating: 7.8,
    cover: 'https://readdy.ai/api/search-image?query=Action%20crime%20movie%20poster%2C%20high%20speed%20car%20chase%20at%20night%2C%20city%20highway%20with%20orange%20street%20lights%20and%20deep%20blue%20night%20sky%2C%20dynamic%20cinematic%20composition&width=640&height=900&seq=show-movie-005-a&orientation=portrait',
    summary: '一名退役特工被迫重返江湖，为保护家人独自对抗整个犯罪集团的围追堵截。',
    synopsis:
      '退役特工杰克原本过着平静的生活，却因女儿意外卷入一桩跨国军火交易案而被迫重操旧业。为了营救女儿，他只身对抗一个庞大的犯罪网络，在城市与边境之间展开一场场惊险追逐。影片节奏紧凑，动作场面火爆写实，枪战与飙车场景一气呵成，是一部肾上腺素飙升的硬核动作佳作。',
    director: 'Marcus Reed',
    cast: ['杰克·莫里森', '艾米丽·莫里森'],
    airInfo: '2025年全球院线上映',
    tags: ['动作', '追逐', '特工'],
  },
  {
    id: 'tv-007',
    title: '法庭之外',
    type: 'tv',
    genres: ['律政', '剧情'],
    region: '内地',
    year: 2024,
    rating: 8.0,
    cover: 'https://readdy.ai/api/search-image?query=Legal%20drama%20poster%2C%20courtroom%20interior%20with%20deep%20navy%20blue%20tone%2C%20lawyer%20silhouette%20holding%20documents%2C%20warm%20orange%20accent%20lighting%2C%20professional%20cinematic%20composition&width=640&height=900&seq=show-tv-007-a&orientation=portrait',
    summary: '新人律师在一系列疑难案件中成长蜕变，用法律与良知捍卫每一份迟来的正义。',
    synopsis:
      '初入律所的年轻律师沈清辞承接了一桩看似简单实则疑点重重的民事纠纷案，由此卷入一连串牵涉社会热点的案件之中。从职场性别歧视到企业环境污染，每一宗案件都折射出现实社会的复杂面相。沈清辞在资深律师的指导下逐渐成长，也在一次次庭审交锋中坚定了自己对法律与公正的信念。全剧节奏紧凑，台词犀利，是一部兼具专业质感与现实关怀的律政剧佳作。',
    director: '龚晓丹',
    cast: ['沈清辞', '顾正阳', '季远'],
    airInfo: '2024年已完结，全32集',
    tags: ['律政', '职场', '现实'],
  },
  {
    id: 'movie-006',
    title: '深海之约',
    type: 'movie',
    genres: ['爱情', '剧情'],
    region: '韩国',
    year: 2024,
    rating: 7.9,
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20movie%20poster%2C%20couple%20standing%20by%20the%20ocean%20at%20twilight%2C%20deep%20navy%20blue%20sea%20with%20warm%20orange%20sunset%20reflection%2C%20emotional%20cinematic%20composition&width=640&height=900&seq=show-movie-006-a&orientation=portrait',
    summary: '一场海边偶遇牵起两个破碎灵魂的羁绊，他们在彼此的陪伴中学会重新爱与被爱。',
    synopsis:
      '失去挚爱的摄影师秀妍为疗愈伤痛独自前往海边小镇，邂逅了同样背负丧亲之痛的渔船船长道贤。两个素不相识的人因一场意外事故被迫共处，在朝夕相处中逐渐卸下心防，彼此治愈。影片以细腻唯美的海景镜头作为情感载体，讲述了一个关于失去与重新开始的温柔故事，上映后收获大量观众的情感共鸣。',
    director: '朴恩惠',
    cast: ['秀妍', '道贤'],
    airInfo: '2024年院线上映',
    tags: ['爱情', '治愈', '海洋'],
  },
];